// src/data/pharmacistMockData.js

export const inventoryMockData = [
  {
    id: 1,
    name: 'Sertraline',
    category: 'Mental Health',
    stock: 5,
    stockStatus: 'Low Stock',
    expiry: '2024-05-12',
    reorderHistory: 'Last reordered on 2023-08-15',
  },
  {
    id: 2,
    name: 'Lorazepam',
    category: 'Mental Health',
    stock: 0,
    stockStatus: 'Out of Stock',
    expiry: '2023-10-01',
    reorderHistory: 'Last reordered on 2023-06-10',
  },
  {
    id: 3,
    name: 'Fluoxetine',
    category: 'Mental Health',
    stock: 12,
    stockStatus: 'In Stock',
    expiry: '2025-02-15',
    reorderHistory: 'No reorder history available',
  },
];

export const supplierMockData = [
  {
    id: 1,
    name: 'HealthMed Supplies',
    contact: '123-456-7890',
  },
  {
    id: 2,
    name: 'Pharma Global',
    contact: '987-654-3210',
  },
];

export const restockHistoryMockData = [
  {
    id: 1,
    medication: 'Sertraline',
    quantity: 20,
    supplier: 'HealthMed Supplies',
    expectedDelivery: '2023-09-20',
  },
  {
    id: 2,
    medication: 'Lorazepam',
    quantity: 30,
    supplier: 'Pharma Global',
    expectedDelivery: '2023-09-25',
  },
];
